import React, { useEffect } from 'react';
import { useAppNavigate } from '../../../Hooks/back/useAppNavigate';
import NoticeList from '../ui/NoticeList';
import PostList from '../ui/PostList';
import { CommonActions } from '../../../Reducer/CommonReducer';
import { useDispatch, useSelector } from 'react-redux';
import { NavBarInfoActions } from '../../../Reducer/NavBarInfoReducer';
import WriteFAB from '../../../Components/Ui/WriteFAB';

function M_NOT_BASIC(props) {
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const { navigate } = useAppNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(NavBarInfoActions.setType('titleBar'));
    dispatch(NavBarInfoActions.setTitleName('공지 / 게시'));
    dispatch(CommonActions.resetActiveStep());
  }, []);

  const handleWriteClick = () => {
    navigate('/M_Notice/write');
    dispatch(CommonActions.increaseStep());
  };

  return (
    <div className="bg-background-light flex h-full w-full flex-col">
      {/* 탭 영역 - 고정 */}
      <div className="sticky top-0 z-40 border-b border-slate-100 bg-white">
        <div className="flex">
          <button
            onClick={() => props.setValue(0)}
            className={`flex-1 p-3 text-center transition-colors ${
              props.value === 0
                ? 'border-primary border-b-2 font-bold text-[#2CA900]'
                : 'border-b-2 border-transparent text-slate-500 '
            }`}
          >
            공지
          </button>
          <button
            onClick={() => props.setValue(1)}
            className={`flex-1 py-3.5 text-center transition-colors ${
              props.value === 1
                ? 'text-primary border-primary border-b-2 font-bold'
                : 'font-md border-b-2 border-transparent text-slate-500 '
            }`}
          >
            게시
          </button>
        </div>
      </div>

      {/* 리스트 영역 - 스크롤 */}
      <div className="bg-background-light min-h-0 flex-1 overflow-auto">
        {props.value === 0 && (
          <NoticeList rowData={props.rowData1} userInfo={userInfo} />
        )}
        {props.value === 1 && (
          <PostList postData={props.rowData2} userInfo={userInfo} />
        )}
      </div>

      {/* 플로팅 작성 버튼 */}
      {props.value === 0 &&
        (userInfo.authCd === 'ADMIN' ||
          userInfo.authCd === 'HEAD_MANAGER' ||
          userInfo.authCd === 'BUSINESS_OWNER') && (
          <WriteFAB handleWriteClick={handleWriteClick} />
        )}
    </div>
  );
}

export default M_NOT_BASIC;
